import { LinearProgress, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useFindUserByIdUsersIdGetQuery } from "api";
import { ErrorPage } from "components/pages";
import { IZone } from "interfaces/zone.interface";

import { EditUserForm } from "./forms/EditUserForm";

type UserViewPageProps = {
  zones: IZone[];
};

export const UserEditPage = ({ zones }: UserViewPageProps) => {
  const { t } = useTranslation();
  const { userId } = useParams();

  const {
    data: userData,
    isLoading,
    isError,
    refetch,
  } = useFindUserByIdUsersIdGetQuery(
    {
      id: userId ?? "",
      embed: ["zones"],
    },
    { skip: !userId },
  );

  const user = userData?.data;

  if (isLoading) {
    return <LinearProgress variant={"indeterminate"} />;
  }

  if (isError) {
    return (
      <ErrorPage
        title={t("Failed to load data")}
        buttonText={t("Try again")}
        buttonOnClick={refetch}
      />
    );
  }

  if (!user) {
    return <Typography>{t("no_user_found")}</Typography>;
  }

  const userWithZones = {
    ...user,
    zones: {
      data:
        user.zones?.data?.map((zone) => ({
          ...zone,
          level: zone.level ?? 0,
          hasAccess: true,
          hasPartialAccess: true,
        })) ?? [],
    },
  };

  return (
    <EditUserForm key={userWithZones.id} zones={zones} user={userWithZones} />
  );
};
